import { useEffect, useState } from 'react'
import Default from 'components/layouts/Default/Default';
import DashboardPage from 'components/templates/Dashboard/DashboardPage';
import {
  useAppDispatch,
  useAppSelector,
} from 'app/hooks';
import {
  getDashboardData,
  selectDashboard,
} from 'features/dashboard/dashboardSlice';

import {
  getAdvertisementData,
  selectAdvertisements
} from 'features/advertisement/advertisementSlice';

const Dashboard = () => {
  const dispatch = useAppDispatch();
  const {
    data, 
    pending, 
    error,
  } = useAppSelector(selectDashboard);
  const {
    advtData
  } = useAppSelector(selectAdvertisements);
  const [dashboardData, setDashboardData] = useState({})

  useEffect(() => {
    dispatch(getAdvertisementData())
    // getDashboard()
  }, [])
  return (
    <Default>
      <DashboardPage data={data} />
    </Default>
  )
}
export default (Dashboard);